import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class ToastrService {

    snackBarRef: any;

    constructor(public snackBar: MatSnackBar) {}

    openSnackBar(message: string, action: string, time?: number) {
        const fallbackMessage = 'Something went wrong! Please try again.';
        this.snackBarRef = this.snackBar.open(message || fallbackMessage, action, { duration: (time || 3000), panelClass: "toast-dialog" });
    }

    dismissSnackBar() {
        this.snackBarRef.dismiss();
    }
}
